var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c("FabricRangeSelector", {
        attrs: {
          type: _vm.item.type,
          value: _vm.selectedFabricGroup,
          v: _vm.$v.selectedFabricGroup,
          error: _vm.$v.selectedFabricGroup.$error
        },
        on: {
          "selected-fabric-group": function($event) {
            ;(_vm.selectedFabricGroup = $event), _vm.showWeightedOrNot()
          }
        }
      }),
      _vm._v(" "),
      _c("FabricSelector", {
        attrs: {
          fabricGroupID: _vm.selectedFabricGroup,
          value: _vm.item.fabric
        },
        on: {
          "selected-fabric": function($event) {
            _vm.selectedFabric = $event
          },
          weighted: function($event) {
            ;(_vm.weightedFabric = $event), _vm.showWeightedOrNot()
          }
        }
      }),
      _vm._v(" "),
      _c("ColorSelector", {
        attrs: { fabricID: _vm.selectedFabric, value: _vm.item.color },
        on: {
          "selected-color": function($event) {
            _vm.item.color = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Heading",
          value: _vm.item.variations.heading,
          options: [
            "S Fold",
            "Double Pinch Pleat",
            "Triple Pinch Pleat",
            "Pencil Pleat",
            "Knife Pleat"
          ],
          v: _vm.$v.item.variations.heading,
          error: _vm.$v.item.variations.heading.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.heading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("DimensionSelector", {
        ref: "dimensionSelector",
        attrs: {
          valueName: _vm.item.name,
          valueWidth: _vm.item.width,
          valueDrop: _vm.item.drop,
          valueStackOption: _vm.item.variations.stackOption,
          type: this.item.type
        },
        on: {
          room: function($event) {
            return _vm.setRoom($event)
          },
          ready: function(isReady) {
            return (_vm.readyToSubmitDimension = isReady)
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Fitting",
          value: _vm.item.variations.fitting,
          options: ["Face Fit", "Top Fit"],
          v: _vm.$v.item.variations.fitting,
          error: _vm.$v.item.variations.fitting.$error
        },
        on: {
          "selected-option": function($event) {
            ;(_vm.item.variations.fitting = $event), _vm.resetTrackColor()
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Stack Option",
          value: _vm.item.variations.stackOption,
          options: [
            "Centre Open",
            "Left Stack",
            "Right Stack",
            "Multiple Openings"
          ],
          v: _vm.$v.item.variations.stackOption,
          error: _vm.$v.item.variations.stackOption.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.stackOption = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.item.variations.stackOption === "Multiple Openings"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Curtain Splits",
              value: _vm.item.variations.curtainSplits,
              options: [
                "Split in the centre",
                "One custom split",
                "Two custom split"
              ],
              v: _vm.$v.item.variations.curtainSplits,
              error: _vm.$v.item.variations.curtainSplits.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.curtainSplits = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "" } },
            [
              _vm.$v.item.variations.splitMeasurementsValue1.$error
                ? _c("div", { staticClass: "red--text" }, [
                    _vm._v("Please enter Split Measurement A")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.item.variations.curtainSplits &&
              _vm.item.variations.curtainSplits.includes("custom split")
                ? _c("v-text-field", {
                    attrs: { label: "A" },
                    model: {
                      value: _vm.item.variations.splitMeasurementsValue1,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.item.variations,
                          "splitMeasurementsValue1",
                          $$v
                        )
                      },
                      expression: "item.variations.splitMeasurementsValue1"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.item.variations.curtainSplits === "Two custom split"
            ? _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "" } },
                [
                  _vm.$v.item.variations.splitMeasurementsValue2.$error
                    ? _c("div", { staticClass: "red--text" }, [
                        _vm._v("Please enter Split Measurement B")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.variations.curtainSplits &&
                  _vm.item.variations.curtainSplits.includes("custom split")
                    ? _c("v-text-field", {
                        attrs: { label: "B" },
                        model: {
                          value: _vm.item.variations.splitMeasurementsValue2,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.item.variations,
                              "splitMeasurementsValue2",
                              $$v
                            )
                          },
                          expression: "item.variations.splitMeasurementsValue2"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Track Type",
          value: _vm.item.variations.trackType,
          options: _vm.trackTypeOptions,
          v: _vm.$v.item.variations.trackType,
          error: _vm.$v.item.variations.trackType.$error
        },
        on: {
          "selected-option": function($event) {
            ;(_vm.item.variations.trackType = $event),
              _vm.trackTypeChanged($event)
          }
        }
      }),
      _vm._v(" "),
      _vm.item.variations.trackType !== "Motorised"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Track Color",
              value: _vm.item.variations.trackColor,
              options: ["White", "Black", "Anodised Silver"],
              v: _vm.$v.item.variations.trackColor,
              error: _vm.$v.item.variations.trackColor.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.trackColor = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.trackType !== "Motorised"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Wand Option",
              value: _vm.item.variations.wandOption,
              options: ["910mm", "1220mm", "1520mm", "No Wand"],
              v: _vm.$v.item.variations.wandOption,
              error: _vm.$v.item.variations.wandOption.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.wandOption = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.trackType !== "Motorised"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Track Flow",
              value: _vm.item.variations.trackFlow,
              options: ["Fixed Flow", "Free Flow"],
              v: _vm.$v.item.variations.trackFlow,
              error: _vm.$v.item.variations.trackFlow.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.trackFlow = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.trackType === "Motorised"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Motor",
              value: _vm.item.variations.motor,
              options: _vm.motorOptions,
              v: _vm.$v.item.variations.motor,
              error: _vm.$v.item.variations.motor.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.motor = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.trackType === "Motorised"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Remote",
              value: _vm.item.variations.remote,
              options: [
                "Situo Pure 1 channel",
                "Situo Pure 5 channel",
                "No Remote"
              ],
              v: _vm.$v.item.variations.remote,
              error: _vm.$v.item.variations.remote.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.remote = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.trackType === "Motorised" &&
      _vm.item.variations.motor === "Irismo 45 WireFree RTS"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Charger",
              value: _vm.item.variations.charger,
              options: ["Irismo 45 Li-ion Charger", "No Charger"],
              v: _vm.$v.item.variations.charger,
              error: _vm.$v.item.variations.charger.$error
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.charger = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.item.variations.trackType === "Motorised"
        ? _c("CustomizationSelector", {
            attrs: {
              title: "Automation",
              value: _vm.item.variations.automation,
              options: ["Somfy Connexoon", "None"],
              v: _vm.$v.item.variations.automation
            },
            on: {
              "selected-option": function($event) {
                _vm.item.variations.automation = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Finish to Floor",
          value: _vm.item.variations.finishToFloor,
          options: [
            "Off the Floor",
            "Just Touching",
            "5mm Puddle",
            "10mm Puddle",
            "20mm Puddle"
          ],
          v: _vm.$v.item.variations.finishToFloor,
          error: _vm.$v.item.variations.finishToFloor.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.finishToFloor = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Bottom Finish",
          value: _vm.item.variations.bottomFinish,
          options: _vm.bottomFinishOptions,
          v: _vm.$v.item.variations.bottomFinish,
          error: _vm.$v.item.variations.bottomFinish.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.bottomFinish = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.incInstall
        ? _c(
            "div",
            [
              _c("v-checkbox", {
                attrs: { label: "Install?", color: "primary" },
                model: {
                  value: _vm.customInstall,
                  callback: function($$v) {
                    _vm.customInstall = $$v
                  },
                  expression: "customInstall"
                }
              }),
              _vm._v(" "),
              _vm.customInstall
                ? _c("v-text-field", {
                    attrs: { label: "Install Price" },
                    model: {
                      value: _vm.item.installPrice,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "installPrice", $$v)
                      },
                      expression: "item.installPrice"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-textarea", {
        attrs: { name: "notes", label: "Line Item Notes" },
        model: {
          value: _vm.item.notes,
          callback: function($$v) {
            _vm.$set(_vm.item, "notes", $$v)
          },
          expression: "item.notes"
        }
      }),
      _vm._v(" "),
      !_vm.edit
        ? _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Add " + _vm._s(_vm.item.type))]
          )
        : _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Update " + _vm._s(_vm.item.type))]
          ),
      _vm._v(" "),
      _c("b", [_vm._v("$" + _vm._s(_vm.item.total.toFixed(2)))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b7a9d52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b7a9d52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/Curtain.vue
// module id = null
// module chunks = 